import { Component } from '@angular/core';
import { PageHeader } from '@components/page-header/page-header';
import { CalendarComponent } from '@components/calendar/calendar';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.page.html',
  styleUrl: './calendario.page.css',
  standalone: true,
  imports: [PageHeader, CalendarComponent],
})
export class Calendario {}
